import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-betting.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import NewsletterPartner from "../newsletter-partner"

const NewsletterBetting = ({ section }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <Heading level={4} className={styles.title}>
          {section.title}
        </Heading>
        <NewsletterPartner
          section={section}
          dictionary={allSanityDictionary.nodes}
        />
      </div>
      <div className={styles.teams}>
        <div className={styles.team}>
          {section.teams[0].logo ? (
            <a
              href={`${section.page ? `/page/${section.page.slug.current}` : "/poll"}?poll_id=${section.poll_id}&answer=${section.teams[0].name}`}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                {...section.teams[0].logo}
                width={80}
                className={styles.teamLogo}
                alt={section.teams[0].name}
              />
            </a>
          ) : (
            ""
          )}
          <Heading level={4} className={styles.teamName}>
            {section.teams[0].name}
          </Heading>
        </div>
        <div className={styles.label}>
          {
            allSanityDictionary.nodes.find((item) => item.key.current === "at")
              ?.value
          }
        </div>
        <div className={styles.team}>
          {section.teams[1].logo ? (
            <a
              href={`${section.page ? `/page/${section.page.slug.current}` : "/poll"}?poll_id=${section.poll_id}&answer=${section.teams[1].name}`}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                {...section.teams[1].logo}
                width={80}
                className={styles.teamLogo}
              />
            </a>
          ) : (
            ""
          )}
          <Heading level={4} className={styles.teamName}>
            {section.teams[1].name}
          </Heading>
        </div>
        {section.teams[0].odds && section.teams[1].odds ? (
          <>
            <div className={styles.odds}>{section.teams[0].odds}</div>
            <div className={styles.label}>
              {
                allSanityDictionary.nodes.find(
                  (item) => item.key.current === "to_win"
                )?.value
              }
            </div>
            <div className={styles.odds}>{section.teams[1].odds}</div>
          </>
        ) : (
          ""
        )}
      </div>
      <CopyContainer content={section._rawContent} />
      {section.teams?.length > 0 ? (
        <div className={styles.options}>
          {section.teams.map((team) => (
            <Button
              variant="secondary"
              className={styles.option}
              url={`${section.page ? `/page/${section.page.slug.current}` : "/poll"}?poll_id=${section.poll_id}&answer=${team.name}`}
              target="_blank"
            >
              {team.name}
            </Button>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default NewsletterBetting

NewsletterBetting.propTypes = {
  section: PropTypes.object.isRequired,
}
